export default __webpack_public_path__ + "static/media/1phone.4de37200.jfif";